import apiClient from './client';

/* ── Types ─────────────────────────────────────────────────────────────────── */

export interface ReviewOption {
  id: number;
  letter: string;
  option_text: string;
}

export interface ReviewQuestion {
  question_id: number;
  question_text: string;
  topic: string | null;
  difficulty: string;
  question_type: string;
  correct_answer: string;
  explanation: string | null;
  ease_factor: number;
  interval: number;
  repetitions: number;
  next_review: string | null;
  options: ReviewOption[];
}

export interface DueQuestionsResponse {
  total_due: number;
  items: ReviewQuestion[];
}

export interface ReviewSubmitResponse {
  question_id: number;
  new_ease_factor: number;
  new_interval: number;
  new_repetitions: number;
  next_review: string;
}

export interface ReviewStats {
  total_cards: number;
  due_now: number;
  mastered: number;
  learning: number;
  avg_ease_factor: number;
  avg_interval: number;
}

/* ── API calls ─────────────────────────────────────────────────────────────── */

/** Fetch questions due for spaced repetition review. */
export async function getDueQuestions(
  limit = 20,
  certificationCode?: string,
): Promise<DueQuestionsResponse> {
  const params: Record<string, string | number> = { limit };
  if (certificationCode) params.certification_code = certificationCode;
  const { data } = await apiClient.get<DueQuestionsResponse>('/api/review/due', { params });
  return data;
}

/** Submit a review answer with SM-2 quality rating. */
export async function submitReview(
  questionId: number,
  quality: number,
): Promise<ReviewSubmitResponse> {
  const { data } = await apiClient.post<ReviewSubmitResponse>('/api/review/submit', {
    question_id: questionId,
    quality,
  });
  return data;
}

/** Get review statistics for the dashboard. */
export async function getReviewStats(): Promise<ReviewStats> {
  const { data } = await apiClient.get<ReviewStats>('/api/review/stats');
  return data;
}
